import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { BatchActionsToolbarComponent } from '@aiwyn/foundations/components';
import { ConfigModule } from '@anduin/config';
import { SharedModule } from '@anduin/shared';
import { NgxsModule } from '@ngxs/store';
import { AgGridModule } from 'ag-grid-angular';
import { InvoicesTableComponent, ResendInvoiceDialogComponent } from './components';
import { CreatePaymentDrawerComponent } from './components/create-payment-drawer/create-payment-drawer.component';

@NgModule({
  declarations: [InvoicesTableComponent],
  exports: [InvoicesTableComponent],
  imports: [
    CommonModule,
    ConfigModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatButtonToggleModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatBottomSheetModule,
    MatRadioModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    SharedModule,
    AgGridModule,
    NgxsModule,

    //Standalone Components
    BatchActionsToolbarComponent,
    CreatePaymentDrawerComponent,
    ResendInvoiceDialogComponent,
  ],
  providers: [],
})
export class CommonInvoicesModule {}
